import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { isChunkLoadError } from '~/containers/PostHogConsentManager';

// Create a new router instance
export const router = createRouter({
  routeTree,
  defaultOnCatch: (error) => {
    if (error instanceof Error && isChunkLoadError(error.message)) {
      // A new version was deployed and the browser has stale asset references.
      // Reload once to fetch the latest chunks.
      window.location.reload();
    }
  },
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
